export default class RollForwardAccountDateRequest {
    startDateUtc: string;
    endDateUtc: string;
    accountId: string;
}